import styled from '@emotion/styled';

import { useAppDispatch, useAppSelector } from 'store/config';
import { contractService } from 'store/slices/contractSlice';

type Props = {
  setOnModal: any;
};

const ChildFail = ({ setOnModal }: Props) => {
  const isMobile = useAppSelector((state) => state.global.isMobile);
  const dispatch = useAppDispatch();
  const onClickRetry = () => {
    // 모달
    setOnModal(false);
    // 민팅 재시도
    if (isMobile) {
      dispatch(contractService.publicMintWithEthers(1));
    } else {
      dispatch(contractService.publicMint(1));
    }
  };

  return (
    <SuccessInfoWrapper>
      <Badge src='images/modal_fail.png' alt='fail badge' />
      <ContentsWrapper>
        <TitleWrapper>
          <Title>민팅실패</Title>
          <SubTitle>민팅에 실패했어요. 다시 시도해주세요.</SubTitle>
        </TitleWrapper>
        <MintImage src='images/modal_fail_content.png' alt='fail image' />
      </ContentsWrapper>
      <ExtraLink onClick={onClickRetry}>다시 시도하기</ExtraLink>
    </SuccessInfoWrapper>
  );
};

export const Badge = styled.img`
  position: absolute;
  top: -40px;

  width: 73px;
  height: 73px;
  object-fit: contain;
`;

const SuccessInfoWrapper = styled.div`
  position: relative;
  box-sizing: border-box;
  padding-top: 51px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 100%;
`;

const MintImage = styled.img`
  width: 180px;
  height: 180px;

  object-fit: contain;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 15px;

  width: 100%;
`;

const ContentsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 30px;
`;

const Title = styled.div`
  text-align: center;
  font-size: 26px;
  font-weight: 600;
  color: #ed4d4d;
`;

const SubTitle = styled.div`
  text-align: center;
  font-size: 16px;
  color: #505050;
`;

const ExtraLink = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 360px;
  height: 60px;
  background-color: #ed4d4d;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;

  cursor: pointer;
  vertical-align: middle;
  font-size: 20px;
  :hover {
    background-color: #f7aedc;
  }
`;

export default ChildFail;
